import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import moment, { Moment } from 'moment'

import { IDayResult } from '../../Client/IResult'

// import DateFormats from '../../../../App/Helpers/DateFormats'
// import MoneyFormatter from '../../../../App/Helpers/MoneyFormatter'
import { IProps } from './IProps'
import { Currency } from '../../../../App/Components/Format'

const Body: FunctionComponent<IProps> = ({ result }) => {
    const { t } = useTranslation()
    const getRow = (
        expense: {
            amount: any
            currency: string
            expendedAt: Moment
            reason: string
        },
        index: number
    ) => {
        return (
            <tr
                key={
                    'dayResultRow' +
                    moment(expense.expendedAt).format('YYYYMMDD') +
                    index
                }
            >
                <td key={'Date'}>
                    {moment(expense.expendedAt).format('D MMMM YYYY')}
                </td>
                <td key={'Description'}>{expense.reason}</td>
                <td key={'Totals'} className={'text-right'}>
                    <Currency>{expense.amount / 100}</Currency>
                </td>
            </tr>
        )
    }

    return (
        <tbody>
            {result.map((expense, index) => getRow(expense, index))}
        </tbody>
    )
}

export default Body
